export function toVoiceAssessmentVASGraphProps({
  attributeName,
  learnerValue,
  referenceValues = [],
}) {
  return {
    attributeName,
    userValues: Number.isFinite(Number(learnerValue))
      ? [{ value: Number(learnerValue) }]
      : [],
    sharedValues: referenceValues
      .filter(value => Number.isFinite(Number(value)))
      .map(value => ({ value: Number(value), raterSource: "pvqdRater" })),
    sessionValues: [],
    consensusValues: [],
  };
}
